export * from './locales';

export const LoadingImageUrl = 'https://a.storyblok.com/f/159374/267x150/f2782ab084/loading.svg';
export const NottaLogoWhite = 'https://www.notta.ai/pictures/Showcase-page-Notta-logo.png';
export const NottaLogoDark = 'https://www.notta.ai/pictures/Logo-Notta-Dark-202404191230.png';

export const ShowcaseWhiteLogo = 'https://www.notta.ai/pictures/showcase-brand-logo-white-202403151623.png';
export const ShowcaseBlackLogo = 'https://www.notta.ai/pictures/showcase-brand-logo-black-202403151623.png';

export const WEB_APP_DEV_HOST_URL = 'https://dev-c0ee1fac76df136a.notta.ai';
export const WEB_APP_TEST_HOST_URL = 'https://test-app-12154205867b06a3.notta.ai';
export const WEB_APP_UAT_HOST_URL = 'https://uat-app.notta.ai';
export const WEB_APP_HOST_URL = 'https://app.notta.ai';

const getHostUrlByEnv = () => {
  if (process.env.GATSBY_PROJECT_ENV === 'dev') {
    return WEB_APP_DEV_HOST_URL;
  } else if (process.env.GATSBY_PROJECT_ENV === 'test') {
    return WEB_APP_TEST_HOST_URL;
  } else if (process.env.GATSBY_PROJECT_ENV === 'uat') {
    return WEB_APP_UAT_HOST_URL;
  } else {
    return WEB_APP_HOST_URL;
  }
};

/** 是否为开发环境 */
export const isDevEnv = process.env.GATSBY_STORYBLOCK_VERSION === 'draft';

export const WEB_APP_EN_SIGN_UP_URL = `${getHostUrlByEnv()}/signup?language=en&from=official`;

export const WEB_APP_JP_SIGN_UP_URL = `${getHostUrlByEnv()}/signup?language=jp&from=official`;

export const WEB_APP_EN_LOGIN_IN_URL = `${getHostUrlByEnv()}/login?language=en&from=official`;

export const WEB_APP_JP_LOGIN_IN_URL = `${getHostUrlByEnv()}/login?language=jp&from=official`;

export const WEB_APP_HOME_URL = `${getHostUrlByEnv()}/?from=official`;

export const SHOWCASE_WEB_APP_SIGNUP_URL = `${getHostUrlByEnv()}/showcase/signup?language=en&from=official`;

export const SHOWCASE_WEB_APP_LOGIN_URL = `${getHostUrlByEnv()}/showcase/login?language=en&from=official`;

export interface IImageProp {
  src: string;
  alt: string;
}

export type ButtonType = 'default' | 'primary' | 'link';

export interface ICmsRichText {
  type: 'doc';
  content: Array<object>;
}
export interface ICMSAsset {
  id: number;
  alt: string;
  name: string;
  focus: string;
  title: string;
  filename: string;
  copyright: string;
  fieldtype: string;
  is_external_url: boolean;
}

export const isEmailLinkType = (type) => type === 'email';

export const HONOR_LOGOS: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/286x60/54bba3e737/01.svg',
    alt: '作業効率改善に最適AI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/266x60/f6342a232c/02.svg',
    alt: 'データの安全性で選びたいAI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/276x60/b91de5789b/03.svg',
    alt: '経営者がおすすめするAI文字起こしサービス',
  },
];

export const HONOR_LOGOS_WITH_NUMBER: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/286x60/41d0079c56/1.svg',
    alt: '作業効率改善に最適AI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/267x60/19e4bd7621/2.svg',
    alt: 'データの安全性で選びたいAI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/279x60/2aabaaf0d3/3.svg',
    alt: '経営者がおすすめするAI文字起こしサービス',
  },
];

export const HOST_URL =
  process.env.GATSBY_PROJECT_ENV === 'dev'
    ? 'https://localhost:8000'
    : process.env.GATSBY_PROJECT_ENV === 'test'
    ? 'https://test-12154205867b06a3.notta.ai'
    : process.env.GATSBY_PROJECT_ENV === 'uat'
    ? 'https://uat--notta-official.netlify.app'
    : 'https://www.notta.ai';

export enum HTTP_RESPONSE_CODE {
  /** @desc 请求超时，前端自定义的字段 */
  TIMEOUT = Infinity,
  /** ----------------------- Common: -------------------------- */
  /** @desc 成功 */
  SUCCESS = 0,
  /** @desc 失败 */
  FAILED = -1,
  /** @desc 服务错误 */
  SERVER_ERROR = 40000,
}
